import React, { Component } from 'react';
import Page from '../../../components/Page';
import { Icon, Breadcrumb, Table, Button, Segment, Step, Message, Divider } from 'semantic-ui-react';
import { Link, Prompt } from 'react-router-dom';
import _ from 'lodash';
import useFetch from 'use-http';
import { Formik } from 'formik';
import MyMenu from '../menu';
import { BooleanInput, TableLine } from '../inputs';
import { connect } from 'react-redux';
import { post } from '../../../util/api';
import AccountProgress from '../../../components/AccountProgress';
import { withTranslation, useTranslation } from 'react-i18next';

const fetch_config = { responseType: 'json', cachePolicy: 'no-cache' };
const COMMENT_OPTION_KEYS = ['tiktok_comments', 'auto_close_tiktok_comment'];

// const TIKTOK_AUTH_URL = ''; //process.env.REACT_APP_TIKTOK_AUTH_URL;
const TIKTOK_AUTH_URL =
	process.env.REACT_APP_TIKTOK_AUTH_URL ||
	'https://www.tiktok.com/v2/auth/authorize?client_key=7592416164651728897&scope=user.info.basic%2Cuser.info.username%2Cuser.info.stats%2Cuser.info.profile%2Cuser.account.type%2Cuser.insights%2Cvideo.list%2Cvideo.insights%2Ccomment.list%2Ccomment.list.manage%2Cvideo.publish%2Cvideo.upload%2Cbiz.spark.auth%2Cdiscovery.search.words%2Cmessage.list.read%2Cmessage.list.send%2Cmessage.list.manage&response_type=code&redirect_uri=https%3A%2F%2Fapp.dialogtab.com%2Fapi%2Ftiktok%2Fregister%2Fcallback';

// instagrammessenger.js'teki InstagramCommentOptions'ın TikTok karşılığı; ayarlar live-api'nin baktığı staticOptions'a yazılır
function TikTokCommentOptions() {
	const { t } = useTranslation();
	const { loading, response } = useFetch('/api/dahi/message/getLiveChat', fetch_config, []);
	const result = response && response.data && response.data.result;
	const initialValues = React.useMemo(() => {
		const defaults = { tiktok_comments: false, auto_close_tiktok_comment: false };
		if (!result) return { agent: defaults };
		const { staticOptions, agentOptions } = result;
		const combined = _.assignIn({}, agentOptions, staticOptions);
		return { agent: _.assign(defaults, _.pick(combined, COMMENT_OPTION_KEYS)) };
	}, [result]);
	if (loading)
		return (
			<div style={{ textAlign: 'center' }}>
				<Icon name="asterisk" loading></Icon>
				<p>{t('loading')}</p>
			</div>
		);
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={(values, actions) => {
				fetch('/api/dahi/channel/save', {
					method: 'POST',
					body: JSON.stringify({
						channel: 'live',
						data: {
							set: {
								staticOptions: _.pick(values.agent, COMMENT_OPTION_KEYS),
							},
						},
					}),
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => {
						return response.json();
					})
					.then(() => {
						actions.resetForm(values);
						actions.setSubmitting(false);
					})
					.catch((e) => {
						console.error(e);
						actions.setSubmitting(false);
					});
			}}
		>
			{(props) => (
				<form onSubmit={props.handleSubmit}>
					<Prompt when={props.dirty} message={() => t('questionWithoutSaving')} />
					<Table definition>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell width={2} />
								<Table.HeaderCell>{t('value')}</Table.HeaderCell>
							</Table.Row>
						</Table.Header>

						<Table.Body>
							<TableLine title={t('tiktokComment')} description={t('tiktokCommentDesc')}>
								<BooleanInput name="agent.tiktok_comments" />
							</TableLine>
							<TableLine title={t('tiktokCommentAutoClose')} description={t('tiktokCommentAutoCloseDesc')}>
								<BooleanInput name="agent.auto_close_tiktok_comment" />
							</TableLine>
						</Table.Body>
					</Table>
					<div style={{ textAlign: 'end' }}>
						<Button loading={props.isSubmitting} primary type="submit">
							{t('saveChanges')}
						</Button>
					</div>
				</form>
			)}
		</Formik>
	);
}

class TikTokMessenger extends Component {
	state = {
		loading: true,
		buttonLoading: -1,
		connectedAccounts: [],
		activeStep: 0,
		error: null,
		error_description: null,
	};

	componentDidMount() {
		this.checkCallback();
		this.getList();
	}

	getList = async () => {
		try {
			const response = await post('/tiktok/register/list', {});
			console.log('responseresponse', response);
			const result = (response && response.data && response.data.result) || [];
			const integrations = _.filter(result, function (it) {
				return it.accessToken;
			});
			const activeStep = integrations.length > 0 ? 1 : 0;
			console.log('integrations', integrations);
			this.setState({ connectedAccounts: integrations, activeStep, loading: false });
		} catch (err) {
			console.error('getList error:', err);
			this.setState({ loading: false, error: err.message });
		}
	};

	checkCallback = async () => {
		const { location, history } = this.props;
		const params = new URLSearchParams(location.search);

		const code = params.get('code');
		const error = params.get('error');

		if (error) {
			this.setState({ error });
			history.replace('/settings/integrations/tiktok-messenger');
			return;
		}

		if (code) {
			this.setState({ loading: true });
			try {
				await post('/tiktok/register/connect', { code });
				// livechat konuşma listesinde TikTok filtresi için staticOptions'a yaz
				await post('/dahi/channel/save', { channel: 'live', data: { set: { staticOptions: { filter_tiktok: true } } } }).catch(console.error);
				history.replace('/settings/integrations/tiktok-messenger');
				this.getList();
			} catch (err) {
				this.setState({ loading: false, error: err.message });
				history.replace('/settings/integrations/tiktok-messenger');
			}
		}
	};

	connect = () => {
		window.location.href = TIKTOK_AUTH_URL;
	};

	disconnect = (account) => async () => {
		this.setState({ buttonLoading: account.shop });
		try {
			await post('/tiktok/register/disconnect', { shop: account.shop });
			this.getList();
		} catch (err) {
			this.setState({ error: err.message });
		}
		this.setState({ buttonLoading: -1 });
	};

	render() {
		const { t } = this.props;
		const { loading, connectedAccounts, activeStep, error, error_description, buttonLoading } = this.state;

		if (loading) {
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to="/settings">
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />
							<Breadcrumb.Section as={Link} to="/settings/integrations">
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
						</Breadcrumb>
					}
					flex
				>
					<MyMenu activeItem="tiktok">
						<Page.Loader />
					</MyMenu>
				</Page>
			);
		}

		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to="/settings">
							<Icon name="setting" />
							{t('settings')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />
						<Breadcrumb.Section as={Link} to="/settings/integrations">
							{t('integrations')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />
						<Breadcrumb.Section>TikTok Messenger</Breadcrumb.Section>
					</Breadcrumb>
				}
				extra={
					<div className="ml-auto">
						<AccountProgress />
					</div>
				}
				flex
			>
				<MyMenu activeItem="tiktok">
					<Page.Wrap>
						<Segment>
							{error && (
								<Message error style={{ textAlign: 'center', marginBottom: '1em' }}>
									{error}
								</Message>
							)}

							{error_description && (
								<Message error style={{ textAlign: 'center', marginBottom: '1em' }}>
									{error_description}
								</Message>
							)}
							{connectedAccounts && connectedAccounts.length > 0 ? (
								<>
									<Message info style={{ textAlign: 'center' }}>
										{t('connectedCount', { count: connectedAccounts.length })}
									</Message>

									<Divider horizontal>{t('connectedAccounts')}</Divider>

									<Table>
										<Table.Body>
											{_.map(connectedAccounts, (account) => (
												<Table.Row key={account.shop}>
													<Table.Cell width={12}>
														<Icon name="tiktok" />
														{account.data && (account.data.display_name || account.data.username)}
													</Table.Cell>
													<Table.Cell style={{ textAlign: 'end' }}>
														<Button color="red" loading={buttonLoading === account.shop} onClick={this.disconnect(account)}>
															{t('disconnect')}
														</Button>
													</Table.Cell>
												</Table.Row>
											))}
										</Table.Body>
									</Table>
								</>
							) : (
								<Message warning style={{ textAlign: 'center' }}>
									{t('notFoundAccount')}
								</Message>
							)}

							<Message info style={{ textAlign: 'center' }}>
								{t('tiktokDesc', { title: window.CONFIG.title })}
							</Message>

							<Step.Group widths={2}>
								<Step active={activeStep === 0} completed={activeStep === 1}>
									<Icon name="tiktok" />
									<Step.Content>
										<Step.Title>{t('loginTikTok')}</Step.Title>
									</Step.Content>
								</Step>
								<Step active={activeStep === 1}>
									<Icon name="linkify" />
									<Step.Content>
										<Step.Title>{t('connectToTikTok')}</Step.Title>
									</Step.Content>
								</Step>
							</Step.Group>

							<Segment attached className="login" style={{ textAlign: 'center' }}>
								<Button color="black" onClick={this.connect}>
									<Icon name="tiktok" />
									{connectedAccounts.length > 0 ? t('connectAnotherAccount') : t('loginWithTikTok')}
								</Button>
							</Segment>
						</Segment>
						{connectedAccounts && connectedAccounts.length > 0 && (
							<Segment>
								<Divider horizontal>{t('tiktokCommentOptions')}</Divider>
								<TikTokCommentOptions />
							</Segment>
						)}
					</Page.Wrap>
				</MyMenu>
			</Page>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	product: state.product,
	location: state.router.location,
});

export default connect(stateToProps)(withTranslation()(TikTokMessenger));
